import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import HomePage from './pages/HomePage';
import SobreNosPage from './pages/SobreNosPage';
import PortfolioPage from './pages/PortfolioPage';
import ContatosPage from './pages/ContatosPage';
import PlanosPage from './pages/PlanosPage';
import CoberturaPage from './pages/CoberturaPage';
import SegundaViaPage from './pages/SegundaViaPage';
import './App.css';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-transition">
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/sobre" element={<SobreNosPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/contatos" element={<ContatosPage />} />
        <Route path="/planos" element={<PlanosPage />} />
        <Route path="/cobertura" element={<CoberturaPage />} />
        <Route path="/2via" element={<SegundaViaPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <AnimatedRoutes />
      <WhatsAppButton />
    </BrowserRouter>
  );
}

export default App;
